<template>
  <h1 class="text-center">BezierPlugin</h1>
</template>

<script>
export default {
  name: "BezierPlugin"
}
</script>

<style scoped>

</style>